module.exports = __webpack_public_path__ + "static/13-a09896bc3d4cb29649366f84047f2d2d.jpg";